import {Divider, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../../style/theme';

const {Paragraph, Text} = Typography;
const Content = Layout;

const Uno = () => {
  return (
    <Layout style={{margin: '0 5.2vh 5.2vh 5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className='Title2' style={{color: appColors['ColorNa']}}>Business Model</Paragraph>
        <Paragraph className= 'Title3T' style={{color: appColors['ColorX']}}>State of art</Paragraph>
        <Text className='BaseText2' style={{marginTop: '0%'}}>Searching for previous iGEM projects related to iMoAge, we found some biosensors that incorporate common biomarkers for inflammation or some lateral flow assays. Nevertheless, <b>none of them were focused on inflammaging and just a few erenced aging. </b> Besides iGEM projects, we found some <b>kits related to aging but some of them aren&apos;t used for diagnostic or therapeutic purposes</b> and do not include all the biomarkers that we are proposing. </Text>
      </Content>
      <Divider/>
    </Layout>
  );
};

export default Uno;
